export const debounce = <T extends (...args: unknown[]) => unknown>(func: T, delay: number): T => {
  let timeoutId: NodeJS.Timeout | null;

  return ((...args: Parameters<T>) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      (func as T)(...args);
    }, delay);
  }) as T;
};
